import { Box, Typography } from "@mui/material";
import { brands } from "../../../data/brandsAndProjectsData";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTheme, useMediaQuery } from "@mui/material";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { useTypeOfProjectContext } from "../../../context/portafolioContext";
import { useNavigate } from "react-router-dom";
import { useScrollReveal } from "../../../helpers/ScrollReveal";
import { useLanguageContext } from "../../../context/languageContext";
import { textlanguages } from "../../../data/textOfThePage";

export const PortfolioSection = () => {
  const { languageSelected } = useLanguageContext();
  const { setCompanySelected } = useTypeOfProjectContext();
  const { setProjectSelected } = useTypeOfProjectContext();
  const navigate = useNavigate();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("md"));

  useScrollReveal([
    {
      selector: ".revealFromrightPortfolio",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "right",
        reset: false,
        viewFactor: 0.8,
      },
    },
    {
      selector: ".revealFromLeftPortfolio",
      options: {
        distance: "300px",
        duration: 1000,
        easing: "ease-out",
        origin: "left",
        reset: false,
        viewFactor: 0.1,
      },
    },
    {
      selector: ".revealFromCenterCompanies",
      options: {
        distance: "100px",
        duration: 1000,
        easing: "ease-out",
        origin: "bottom",
        reset: false,
        viewFactor: 0.8,
      },
    },
  ]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: "50px",
          gap: "20px",
          width: "100%",
        }}
      >
        <Typography
          variant="h3"
          sx={{ color: "#005587" }}
          className="revealFromLeftPortfolio"
        >
          {textlanguages[languageSelected].portfolio.title}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            maxWidth: "800px",
            lineHeight: "1.6",
            textAlign: "justify",
            width: { xs: "85%", md: "100%" },
          }}
          className="revealFromrightPortfolio"
        >
          {textlanguages[languageSelected].portfolio.description}
        </Typography>
        <Box sx={{ display: "flex" }} className="revealFromCenterCompanies">
          {isXs || brands.length > 3 ? (
            <Swiper
              spaceBetween={30}
              slidesPerView={isXs ? 1 : 3}
              style={{
                marginTop: "40px",
                paddingBottom: "40px",
                width: "90vw",
                mx: "10px",
                my: "10px",
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                600: { slidesPerView: 2 },
                900: { slidesPerView: 3 },
              }}
              modules={[Navigation]}
              navigation
            >
              {brands[languageSelected].map((item, index) => (
                <SwiperSlide key={item.name} style={{ m: "10px" }}>
                  <Box
                    sx={{
                      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                      px: "40px",
                      py: "25px",
                      borderRadius: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      boxSizing: "border-box",
                      m: "10px",
                    }}
                  >
                    <Box
                      component="img"
                      src={item.logo}
                      sx={{ width: "80px", height: "40px" }}
                    />
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "18px",
                        mt: "10px",
                        height: "54px",
                      }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        bgcolor: "#005587",
                        color: "#fff",
                        px: "20px",
                        py: "4px",
                        borderRadius: "20px",
                        mt: "30px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setCompanySelected(index);
                        setProjectSelected(0);
                        navigate("portfolio");
                      }}
                    >
                      {item.buttonMainPage}
                    </Typography>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Box sx={{ display: "flex", gap: "30px", mt: "40px" }}>
              {brands[languageSelected].map((item, index) => (
                <Box
                  sx={{
                    boxShadow:
                      "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                    px: "40px",
                    py: "25px",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minWidth: "363px",
                  }}
                  key={item.name}
                >
                  <Box
                    component="img"
                    src={item.logo}
                    sx={{ width: "80px", height: "40px" }}
                  />
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "18px",
                      mt: "10px",
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      bgcolor: "#005587",
                      color: "#fff",
                      px: "20px",
                      py: "4px",
                      borderRadius: "20px",
                      mt: "30px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setCompanySelected(index);
                      setProjectSelected(0);
                      navigate("portfolio");
                    }}
                  >
                    {item.buttonMainPage}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
